import { backend, BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { useRouter } from 'next/router';

export function useITicketTypes() {
  const {
    locale,
    query: { slug: querySlug },
  } = useRouter();

  const slug = querySlug?.at(-1) ?? '';
  return useTypeSafeQuery(
    BackendQueryKeys.ITicketTypesList({ locale, slug }),
    ({ ITicket }) => ITicket.listITicketTypes(locale || '', slug),
    {}
  );
}
